module.exports = __webpack_public_path__ + "img/certificate-Javascript_learn_by_game.0e0f0b67.png";